if (!customElements.get('mobile-menu')) {
  class MobileMenu extends HTMLElement {
    constructor() {
      super();

      // Store Locator Button Logic
      this.storeLocatorBtn = this.querySelector('[announcement-store-locator]');
      if (this.storeLocatorBtn) {
        this.storeLocatorBtn.addEventListener('click', () => {
          const store_locator = document.querySelector('store-locator-drawer');
          if (store_locator) {
            store_locator.setAttribute('drawer-open', '');
            setTimeout(() => {
              store_locator.classList.add('drawer-open');
            }, 500);
          }
        });
      }

      // Accordion open/close on focus
      this.detailsElements = this.querySelectorAll('details');

      this.detailsElements.forEach((details) => {
        // Open when focused
         details.addEventListener('click', (e) => {
          if (e.target.tagName === 'A' || e.target.closest('a')) return;
          e.preventDefault()
           if (details.getAttribute('open')) {
              details.removeAttribute('open');
              return;
            }
           this.detailsElements.forEach((removeAttribute)=>{
            removeAttribute.removeAttribute('open');
           })
          details.setAttribute('open', '');
        });
        // details.addEventListener('focusin', () => {
        //   details.setAttribute('open', '');
        // });

        // Close when focus leaves (not when clicking inside)
        // details.addEventListener('focusout', (event) => {
        //   // Use setTimeout so it triggers after focus actually leaves the element
        //   setTimeout(() => {
        //     if (!details.contains(document.activeElement)) {
        //       details.removeAttribute('open');
        //     }
        //   }, 0);
        // });
      });

      this.initMobileMenuTabs();
    }

    initMobileMenuTabs() {
      const mobileMenuTabs = this.querySelectorAll('[data-category-tab]');
      const mobileMenuTabsContent = this.querySelectorAll('[data-category-content]');
      mobileMenuTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          mobileMenuTabs.forEach((t) => {
            t.classList.remove('active');
          });
          tab.classList.add('active');
          mobileMenuTabsContent.forEach((content) => {
            content.classList.remove('active');
          });
          mobileMenuTabsContent[index].classList.add('active');
        });
      });
    }
  }

  customElements.define('mobile-menu', MobileMenu);

  // Lazy-load mega-menu collection products the first time a shopper drills
  // into a collection. The cards are no longer server-rendered (they pushed the
  // hero/LCP far down the HTML); the empty list carries the collection handle.
  function loadMobileCollection(list) {
    if (!list || list.dataset.loaded === 'true' || list.dataset.loading === 'true') return;
    const handle = list.dataset.collectionHandle;
    if (!handle) return;
    list.dataset.loading = 'true';
    list.setAttribute('aria-busy', 'true');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${root}collections/${handle}?section_id=mega-menu-collection-products`)
      .then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then((html) => {
        const listEl = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mega-list]');
        if (listEl) {
          // CUSTOM(fix/megamenu-collection-link): append 而不是覆盖 —— 列表里第一条是
          // 服务端渲染的"直达集合页"链接(snippets/mobile-collections-megamenu.liquid),
          // 用 innerHTML = 会把它冲掉。重复 append 由上面的 loaded/loading 闸门拦住。
          list.insertAdjacentHTML('beforeend', listEl.innerHTML);
          list.dataset.loaded = 'true';
        }
      })
      .catch(() => {})
      .finally(() => {
        list.dataset.loading = 'false';
        list.removeAttribute('aria-busy');
      });
  }

  function triggerMobileCollectionLoad(target) {
    const item = target.closest('[data-menu-item]');
    if (!item) return;
    loadMobileCollection(item.querySelector('.inner-submenu-list[data-collection-handle]'));
  }

  document.addEventListener('click', (e) => triggerMobileCollectionLoad(e.target));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') triggerMobileCollectionLoad(e.target);
  });
}
